import React, { useEffect } from 'react';

import { ViewModelForm } from 'gw-portals-viewmodel-react';
import { useValidation } from 'gw-portals-validation-react';
import './SgDirectDebitDetails.messages';
import _ from 'lodash';
import { SgPaymentUtils } from 'saga-modules';
import metadata from './SgDirectDebitForm.metadata.json5';

function SgDirectDebitForm(props) {
    const {
        id,
        paymentInstrumentVM,
        onValidate: onValidateParent,
        updateData,
        showErrors
    } = props;
    const {
        onValidate,
        isComponentValid,
    } = useValidation(id);

    useEffect(() => {
        if (onValidateParent) {
            onValidateParent(isComponentValid, id);
        }
    }, [id, isComponentValid, onValidateParent]);

    useEffect(() => {
        paymentInstrumentVM.bankAccountData.value = paymentInstrumentVM.bankAccountData.value || {};
    }, []);

    const updatePaymentData = (paymentData) => {
        const newModelVM = _.clone(paymentInstrumentVM);
        if (newModelVM.value.bankAccountData && newModelVM.value.bankAccountData.sortCode_Ext) {
            const sortCode = newModelVM.value.bankAccountData.sortCode_Ext;
            const sortCodeValue = SgPaymentUtils.getFormattedSortCodeValue(sortCode);
            _.set(newModelVM, 'bankAccountData.sortCode_Ext', sortCodeValue);
        }
        _.set(newModelVM, null, paymentData);
        updateData(newModelVM);
    };

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={paymentInstrumentVM}
            onModelChange={updatePaymentData}
            showErrors={showErrors}
            onValidationChange={onValidate}
        />
    );
}

export default SgDirectDebitForm;
